import { z } from 'zod';

const EnvSchema = z.object({
  VITE_API_BASE_URL: z
    .string()
    .catch('')
    .transform((value) => value.replace(/\/+$/, '')),
});

export type AppEnv = { apiBaseUrl: string };

export const parseEnv = (raw: unknown): AppEnv => {
  const parsed = EnvSchema.parse(typeof raw === 'object' && raw !== null ? raw : {});
  return { apiBaseUrl: parsed.VITE_API_BASE_URL };
};

export const env = parseEnv(import.meta.env);
